<template>
  <v-dialog v-model="dialog" persistent max-width="1000">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        outlined
        :color="color"
        class="ml-3"
      >
        <v-icon>{{ icon }}</v-icon><span v-if="edit === false">Adicionar Indicador</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="modal-header elevation-10"
      >
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <br><br>
        <v-row>
          <v-col sm="3">
            <v-select
              id="niveis-select"
              v-model="Id"
              item-text="nomeIndicador"
              item-value="salaIndicadoresId"
              item-name="salaIndicadoresId"
              :items="Indicadores"
              label="Indicador da base"
              placeholder="Indicador da base"
              v-on:change="GetAllIndicadoresFiltro()"
            >
              <template slot="no-data">
                Nenhum Indicador retornado
              </template>
            </v-select>
          </v-col>
          <v-col sm="3">
            <v-text-field
                label="Nome Indicador"
                name="nome"
                type="text"
                required
                v-model="payload.nomeIndicador"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              label="Objeto"
              name="objeto"
              type="text"
              required
              v-model="payload.objeto"
            ></v-text-field>
          </v-col>
           <v-col sm="3">
            <v-text-field
                label="Nivel"
                name="nome"
                type="text"
                required
                v-model="payload.nomeNivel"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
              label="Apuração"
              name="nome"
              type="text"
              required
              v-model="payload.nomeApuracao"
            ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
                label="Fonte"
                name="nome"
                type="text"
                required
                v-model="payload.nomeFonte"
          ></v-text-field>
          </v-col>
          <v-col sm="3">
            <v-text-field
                label="Leitura"
                name="nome"
                type="text"
                required
                v-model="payload.nomeLeitura"
            ></v-text-field>
          </v-col>
           <v-col sm="3">
            <v-text-field
                label="Unidade"
                name="nome"
                type="text"
                required
                v-model="payload.nomeUnidade"
            ></v-text-field>
          </v-col>
           <v-col sm="3">
            <v-text-field
              label="Responsável"
              name="responsavel"
              type="text"
              required
              v-model="payload.responsavel"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="3">
            <v-textarea
              label="Série Histórica"
              name="serie"
              type="text"
              required
              v-model="payload.serie"
            ></v-textarea>
          </v-col>
          <v-col sm="6">
            <v-textarea
              label="Metas"
              name="metas"
              type="text"
              required
              v-model="payload.metas"
            ></v-textarea>
          </v-col>
          <v-col sm="3">
            <v-textarea
              label="Valor da meta"
              name="valor"
              type="text"
              required
              v-model="payload.valorApurado"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
           <v-col sm="3">
            <v-textarea
              label="Previsto"
              name="objeto"
              type="text"
              required
              v-model="payload.previsto"
            ></v-textarea>
          </v-col>
          <v-col sm="3">
            <v-textarea
              label="Realizado"
              name="realizado"
              type="text"
              required
              v-model="payload.realizado"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false">Fechar</v-btn>
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SalaIndicadoresMunicipioAPI } from '../API/SalaIndicadoresMunicipioAPI'
import { mapActions } from 'vuex'

export default {
  name: 'AppModalInsertUr',
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true }
  },
  components: {},
  data () {
    return {
      payload: [
        {
          nomeNivel: '',
          nomeApuracao: '',
          nomeFonte: '',
          nomeLeitura: '',
          nomeUnidade: '',
          nomeIndicador: '',
          objeto: '',
          realizado: '',
          municipioId: 0,
          salaIndicadoresMunicipiosId: 0
        }
      ],
      dialog: false,
      Indicadores: [],
      Id: 0
    }
  },
  mounted () {
    this.loadIndicadores()
    if (this.object && this.edit === true) {
      this.payload = this.object
    }
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    onConfirm () {
      if (this.edit === true) {
        let formData = new FormData()
        formData.append('salaIndicadoresMunicipiosId', this.payload.salaIndicadoresMunicipiosId)
        formData.append('nomenivel', this.payload.nomeNivel)
        formData.append('nomeapuracao', this.payload.nomeApuracao)
        formData.append('nomefonte', this.payload.nomeFonte)
        formData.append('nomeleitura', this.payload.nomeLeitura)
        formData.append('nomeunidade', this.payload.nomeUnidade)
        formData.append('Municipioid', this.payload.municipioId)
        formData.append('serie', this.payload.serie)
        formData.append('responsavel', this.payload.responsavel)
        formData.append('metas', this.payload.metas)
        formData.append('valorapurado', this.payload.valorApurado)
        formData.append('objeto', this.payload.objeto)
        formData.append('previsto', this.payload.previsto)
        formData.append('realizado', this.payload.realizado)
        formData.append('nomeindicador', this.payload.nomeIndicador)

        SalaIndicadoresMunicipioAPI
          .update(formData)
          .then((resp) => {
            this.dialog = false
            this.$emit('on-save')
            location.reload()
          })
          .catch()
      } else {
        let formData = new FormData()

        formData.append('nomenivel', this.payload.nomeNivel)
        formData.append('nomeapuracao', this.payload.nomeApuracao)
        formData.append('nomefonte', this.payload.nomeFonte)
        formData.append('nomeleitura', this.payload.nomeLeitura)
        formData.append('nomeunidade', this.payload.nomeUnidade)
        formData.append('Municipioid', this.payload.municipioId)
        formData.append('serie', this.payload.serie)
        formData.append('responsavel', this.payload.responsavel)
        formData.append('metas', this.payload.metas)
        formData.append('valorapurado', this.payload.valorApurado)
        formData.append('objeto', this.payload.objeto)
        formData.append('previsto', this.payload.previsto)
        formData.append('realizado', this.payload.realizado)
        formData.append('nomeindicador', this.payload.nomeIndicador)

        SalaIndicadoresMunicipioAPI
          .create(formData)
          .then((resp) => {
            this.dialog = false
            this.$emit('on-save')
            location.reload()
          })
          .catch()
      }
    },
    loadIndicadores () {
      this.setLoading(true)
      SalaIndicadoresMunicipioAPI
        .listIndicadores()
        .then(resp => {
          this.Indicadores = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter URs')
        })
    },
    GetAllIndicadoresFiltro () {
      this.setLoading(true)
      SalaIndicadoresMunicipioAPI
        .GetAllIndicadores(this.Id)
        .then(resp => {
          this.payload = resp.data
          this.payload.nomeNivel = this.payload[0].salaIndicadorNiveis.nomeNivel
          this.payload.nomeApuracao = this.payload[0].salaIndicadorApuracao.nomeApuracao
          this.payload.nomeFonte = this.payload[0].salaIndicadorFonte.nomeFonte
          this.payload.nomeLeitura = this.payload[0].salaIndicadorLeitura.nomeLeitura
          this.payload.nomeUnidade = this.payload[0].salaIndicadorUnidade.nomeUnidade
          this.payload.nomeIndicador = this.payload[0].nomeIndicador
          this.payload.objeto = this.payload[0].objeto
          this.payload.responsavel = this.payload[0].responsavel
          this.payload.municipioId = this.$route.params.id
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao obter os indicadores')
        })
    }
  }
}
</script>
